import { render, staticRenderFns } from "./VolunteerMembership.vue?vue&type=template&id=5a1bbd35&scoped=true&lang=pug&"
import script from "./VolunteerMembership.vue?vue&type=script&lang=js&"
export * from "./VolunteerMembership.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerMembership.vue?vue&type=style&index=0&id=5a1bbd35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1bbd35",
  null
  
)

export default component.exports